import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden bg-secondary-200/50 p-8 md:p-12">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-primary-100/50 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-accent-100/50 rounded-full blur-3xl"></div>
          </div>
          <div className="relative z-10 flex flex-col items-center text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-500 flex items-center justify-center mb-4">
              <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center">
                <i className="ri-rocket-2-line text-2xl text-background-50"></i>
              </div>
            </div>
            <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-2">
              开启你的漫画之旅
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mb-6">
              海量免费漫画等你来读！国漫、日漫、韩漫全部免费，下拉式阅读体验让你一次看过瘾。
            </p>
            <div className="flex items-center gap-3 flex-wrap justify-center">
              <Link
                to="/category/guoman"
                className="bg-primary-500 text-background-50 dark:text-foreground-950 px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="bg-background-50 text-foreground-700 border border-background-300 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}